export const firebaseConfig = {
  apiKey: "AIzaSyA5trpaZCPLdJSwN3RruqbFBlEDOfCCcdo",
  authDomain: "distance-calculator-a905f.firebaseapp.com",
  projectId: "distance-calculator-a905f",
  storageBucket: "distance-calculator-a905f.appspot.com",
  messagingSenderId: "614508363574",
  appId: "1:614508363574:web:97587a9b8e88817673fd97",
};
